class SupernovaPopup extends window.BAO.CustomElement {
  connectedCallback () {
    super.connectedCallback()

    if (localStorage.getItem(this.itemKey)) {
      this.remove()
      return
    }

    window.setTimeout(() => {
      this.classList.add('sec-SupernovaPopup-fadeIn')
    }, 2000)
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.els.close.element, 'click', this.close.bind(this))
  }

  close (e) {
    e.preventDefault()

    this.classList.remove('sec-SupernovaPopup-fadeIn')

    localStorage.setItem(this.itemKey, true)

    window.setTimeout(() => {
      this.remove()
    }, 500)
  }

  get itemKey () {
    return 'supernova-popup-closed'
  }
}

if (!customElements.get('supernova-popup')) {
  customElements.define('supernova-popup', SupernovaPopup)
}
